import React, { useEffect } from "react";
import Aos from "aos";
import ImageZoom from "react-medium-image-zoom";
import "aos/dist/aos.css";
import "react-medium-image-zoom/dist/styles.css";
import "./Noticias.css"; // importa o CSS novo

const noticiasData = [
  {
    "data": "04/10/2025",
    "titulo": "Automotive Industry Week",
    "descricao": "Plastifa wird auf der 12. Automotive Industry Week, organisiert von AFIA, vertreten sein! Wir werden am 4., 5. und 6. November im Raum „New York“ im Solverde Hotel in Vila Nova de Gaia sein.",
    "imagem": "images/AFIA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_innovation-automotiveindustry-plastifa-activity-7378706061240926208-qsqS?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "02/10/2025",
    "titulo": "SCORING TOP 5%",
    "descricao": "Plastifa erneuert seinen Status als „TOP 5 % der besten KMU in Portugal“ – zum sechsten Mal in Folge. \nMit großem Stolz geben wir die Erneuerung dieser von SCORING verliehenen Auszeichnung bekannt.",
    "imagem": "images/TOP2025.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plastifa-top5-scoring-activity-7381254954105135104-Rcn0?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "01/09/2025",
    "titulo": "IAA MOBILITY 2025",
    "descricao": "Plastifa freut sich über die Teilnahme an der IAA MOBILITY 2025",
    "imagem": "images/IAA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plasticparts-mobility-automotive-activity-7360664420571578368-TTnd?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
 {
    data: "15/05/2024",
    titulo: "ISO 14001",
    descricao:
      "Plastifa konzentriert sich auf die Umwelt und eine nachhaltigere Zukunft und ist jetzt nach ISO 14001 – Umweltmanagementsysteme – zertifiziert.",
    imagem: "images/14001.jpeg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7196080381643616257",
  },
  {
    data: "23/12/2023",
    titulo: "Eine grünere Zukunft",
    descricao:
      "Plastifa setzt auf Nachhaltigkeit und eine grünere Zukunft und investiert in die Erzeugung von Solarenergie.",
    imagem: "images/PaineisSolares.JPG",
    link: "https://www.linkedin.com/posts/plastifa_com-foco-na-sustentabilidade-e-num-futuro-activity-7157008055249821696-QJP5?utm_source=share&utm_medium=member_desktop",
  },
  {
    data: "25/10/2023",
    titulo: "UNTER DEN TOP 5%",
    descricao:
      "Zum vierten Mal in Folge wurde das Unternehmen als eines der TOP 5% der leistungsstärksten KMU in Portugal in Bezug auf Leistung und Finanzkraft ausgezeichnet!",
    imagem: "images/TOP52023.png",
    zoom: true,
  },
  {
    data: "01/06/2023",
    titulo: "Neues Video",
    descricao:
      "In einer Welt, die von ständigem Fortschritt und Innovation geprägt ist, ist Plastifa stolz darauf, sich als Unternehmen mit Spitzentechnologie und innovativen Ideen zu präsentieren.",
    imagem: "images/NotVideo.png",
    link: "https://www.linkedin.com/posts/plastifa_plastifa-your-partner-for-plastic-parts-activity-7059587841172865024-LQ9A?utm_source=share&utm_medium=member_desktop",
  },
  {
    data: "17/10/2022",
    titulo: "UNTER DEN TOP 5%",
    descricao:
      "Zum dritten Mal in Folge wurde das Unternehmen in Bezug auf Leistung und Finanzkraft als eines der Top 5 % der leistungsstärksten KMU in Portugal ausgezeichnet!",
    imagem: "images/TOPSCORING22.png",
    zoom: true,
  },
  {
    data: "23/12/2021",
    titulo: "Christmas Postcard",
    descricao: "Please click on the image below to access Plastifa Postcard:",
    imagem: "images/Natal-EN.png",
    link: "https://plastifa.pt/Christmas",
  },
  {
    data: "15/11/2021",
    titulo: "UNTER DEN TOP 5%",
    descricao:
      "Zum zweiten Mal in Folge wurde das Unternehmen in Bezug auf Leistung und Finanzkraft als eines der Top 5 % der leistungsstärksten KMU in Portugal ausgezeichnet!",
    imagem: "images/TOP2021.jpg",
    zoom: true,
  },
  {
    data: "24/04/2021",
    titulo: "PME Excelência",
    descricao: "Plastifa erhält das siebte Jahr in Folge den Status „PME Excelência“",
    imagem: "images/PMEex3.png",
    zoom: true,
  },
  {
    data: "24/12/2020",
    titulo: "UNTER DEN TOP 5%",
    descricao:
      "Das Unternehmen zählt zu den Top 5 % der leistungsstärksten KMU in Portugal, gemessen an der wirtschaftlichen Leistungsfähigkeit und Finanzstärke.",
    imagem: "images/TOP52020.jpg",
    zoom: true,
  },
  {
    data: "16/04/2020",
    titulo: "PSA von Plastifa",
    descricao:
      "Im Rahmen des Engagements im Kampf gegen die COVID-19-Pandemie fertigt Plastifa Gesichtsvisiere und Maskenhalterungen.",
    imagem: "images/Viseiras.png",
    zoom: true,
  },
  {
    data: "02/10/2020",
    titulo: "Erweiterung von Werk 2",
    descricao:
      "Plastifa erweitert das Werk 2 mit der Errichtung eines weiteren Gebäudeteils mit 1.000 m² Fläche.",
    "imagem": "images/ExpUn2.jpeg",
    zoom: true,
  },
];

const Noticias = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  return (
    <div className="noticias-wrapper">
      <div className="noticias-grid">
        {noticiasData.map((noticia, idx) => (
          <article key={idx} className="noticia-card" data-aos="fade-up">
            <div className="noticias-row2">
              <label>{noticia.data}</label>
              <h3 className="noticia-titulo">{noticia.titulo}</h3>
            </div>
            <p
              className="noticia-desc"
              dangerouslySetInnerHTML={{
                __html: noticia.descricao.replace(/\n/g, "<br>")
              }}
            ></p>
            <div className="noticia-media">
              {noticia.zoom ? (
                <ImageZoom
                  image={{ src: noticia.imagem, alt: noticia.titulo, className: "noticia-img" }}
                  zoomImage={{ src: noticia.imagem, alt: noticia.titulo }}
                />
              ) : noticia.link ? (
                <a href={noticia.link} target="_blank" rel="noreferrer">
                  <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
                </a>
              ) : (
                <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Noticias;